import { CssModifiers, ConfigObj, PubSub } from '../utils/'

const defaultOpts = {
  contentId: undefined,
  modifier: 'm-toggle-open',
  openText: undefined,
  isOpen: false,
  scrollToId: undefined
}

export default class Toggle {
  constructor($el, opts) {
    this.$el = $el
    this.options = ConfigObj.merge(defaultOpts, opts)
  }

  /**
   * Initializes the class
   */
  init() {
    this.$content = document.querySelector(`#${this.options.contentId}`)

    if (this.$content == null)
      return console.error(
        `#${this.options.contentId} doesn't exist, please provide a unique ID`
      )

    this.$content.classList.add('ps-content-toggle')

    // Assert the requirement for toggling handler text from the options passed in
    this.shouldToggleText = this.options.openText != undefined
    // Store a reference the the original handler text if text toggling is required
    // TODO: Potentially move this to an option prop
    if (this.shouldToggleText) this.defaultHandleText = this.$el.innerText

    // Set the initial state
    this.isOpen = this.options.isOpen

    this.addEventListeners()
    this.toggle()
  }

  scrollToAnchor(anchorId) {
    if (!anchorId) return

    const $anchorEl = document.querySelector(`#${anchorId}`)

    if ($anchorEl == null) return

    const buffer = 100

    // only scroll if the target element is not in the viewport
    const elementPosition = $anchorEl.getBoundingClientRect().top
    const windowBottom = window.scrollY + window.innerHeight + buffer

    if (elementPosition < -buffer || elementPosition > windowBottom)
      window.scrollBy(0, elementPosition - buffer)
  }

  /**
   * Toggle all concerning element states and content
   */
  toggle(e) {
    this.toggleState()

    if (this.shouldToggleText) this.toggleHandleText()

    if (e) {
      PubSub.publish(`toggle:${this.isOpen ? 'open' : 'close'}`, {
        element: this.$el,
        isOpen: this.isOpen
      })
    }

    if (e && this.options.scrollToId && this.isOpen == false)
      this.scrollToAnchor(this.options.scrollToId)

    // Toggle the toggle status
    this.isOpen = !this.isOpen
  }

  /**
   * Toggles the the state of the targeted content and handler
   */
  toggleState() {
    CssModifiers.toggle(this.$el, this.isOpen, this.options.modifier)
    CssModifiers.toggle(this.$content, this.isOpen, this.options.modifier)

    this.$content[this.isOpen ? 'removeAttribute' : 'setAttribute'](
      'aria-hidden',
      true
    )
  }

  /**
   * Toggles the text of the handler if openText is specified
   */
  toggleHandleText() {
    this.$el.innerText = this.isOpen
      ? this.options.openText
      : this.defaultHandleText
  }

  /**
   * Binds event handlers to events
   */
  addEventListeners() {
    this.$el.addEventListener('click', this.toggle.bind(this))
  }
}



// WEBPACK FOOTER //
// ./js/modules/Toggle.js